import { render, staticRenderFns } from "./Upload2.vue?vue&type=template&id=98512422&scoped=true"
import script from "./Upload2.vue?vue&type=script&lang=js"
export * from "./Upload2.vue?vue&type=script&lang=js"
import style0 from "./Upload2.vue?vue&type=style&index=0&id=98512422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98512422",
  null
  
)

export default component.exports